import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import EStores from '../../enums/EStores';
import IFrontendUtilities from "../../interfaces/IFrontendUtilities";
import IFilterSection from "../../interfaces/IFilterSection";
import {getImpersonateSession} from "../../utils/sessionStorage.ts";

type SliceType = {
  futils?: IFrontendUtilities;
  filter?: IFilterSection[];
  impersonate?: boolean;
}

const initialState: SliceType = {
  filter: [],
  impersonate: false,
};

const slice = createSlice({
  name: EStores.FRONTEND_UTILITIES,
  initialState,
  reducers: {
    setFilters(state: SliceType, data: PayloadAction<IFilterSection[]>) {
      return {
        ...state,
        filter: data.payload,
      }
    },
    setFU(state: SliceType, data: PayloadAction<IFrontendUtilities>) {
      return {
        ...state,
        futils: data.payload,
      }
    },
    setImpersonate(state: SliceType) {
      const s = getImpersonateSession()

      return {
        ...state,
        impersonate: !!s,
      }
    }
  },
});

export const {
  setFU,
  setFilters,
  setImpersonate,
} = slice.actions;

export default slice.reducer;
